"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex flex-col w-full justify-center" };
const _hoisted_2 = {
    key: 0,
    class: "block pb-2 font-bold uppercase tracking-wide text-sm"
};
const DropdownInput_vue_1 = __importDefault(require("./DropdownInput/DropdownInput.vue"));
const _locales_1 = __importDefault(require("../../common/i18n/_locales"));
const DropdownInputItem_1 = __importDefault(require("./DropdownInput/DropdownInputItem"));
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'LanguageSelector',
    props: {
        modelValue: {
            type: [String, () => null],
            value: null,
            default: "",
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        placeholder: {
            type: String,
            required: false,
            default: (_a = i18n_1.Translator.trans("language_placeholder", "Choose a language", "language_selector")) !== null && _a !== void 0 ? _a : "Choose a language",
        },
    },
    emits: ["update:modelValue"],
    setup(__props, { emit }) {
        const locales = _locales_1.default.map((locale) => new DropdownInputItem_1.default(locale.locale, `<img src="images/flags/${locale.flag}" alt="${locale.title}" class="w-6 shadow-small-box rounded inline"> <span>${locale.title}</span>`));
        const updateModelValue = (locale) => {
            emit("update:modelValue", locale);
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", _hoisted_1, [
                (__props.label)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, (0, vue_2.toDisplayString)(__props.label), 1))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                    items: (0, vue_2.unref)(locales),
                    placeholder: __props.placeholder,
                    "model-value": __props.modelValue,
                    "onUpdate:modelValue": updateModelValue
                }, null, 8, ["items", "placeholder", "model-value"])
            ]));
        };
    }
});
